module.exports = __webpack_public_path__ + "static/media/empty-box.6221a45a.svg";